// src/components/SearchModal/ItemCard.jsx
import { useState, useEffect, useRef } from "react";
import ItemModal from "./ItemModal";
import LazyImage from "../../components/LazyImage";
import MySwiper from "./MySwiper";
import ItemModalBody from "../ItemModalBody";
import { trackButtonClick } from "../../utils/ItemCardClickedAnalytics"; // 追加
import { Config } from "./Config";
// import "./css/MySwiper.scss";

export default function ItemCard({ props, className }) {
 // propsのチェック
 if (!props || !props.id) {
  // console.error("Invalid item data:", props);
  return null;
 }

 const {
  id,
  item_inhouse_code,
  item_number,
  item_color_en,
  item_color_ja,
  item_series,
  item_category,
  item_subcategory,
  item_size,
  item_heel_range,
  item_heel_cm,
  item_width_range,
  item_width_e,
  item_price,
  item_wp,
  item_material,
  item_toe,
  item_color_attribute_1,
  item_color_attribute_2,
  shape,
  features,
  design,
  freeword,
  // ぴったりチャート専用
  flow_chart_item_heel_cm,
  flow_chart_item_width,
  flow_chart_item_black,
  flow_chart_item_instep,
  flow_chart_other,
  //
  item_badge,
  item_sort_order,
  item_total_images_1,
  item_total_images_2,
  item_total_images_3,
  item_total_video,
  item_jp_link,
  item_ec_link,
 } = props;

 if (!item_inhouse_code) {
  // console.error("Item data is missing:", props);
  return null;
 }

 const getPrefixWidth = (width) => {
  switch (width) {
   case "2E":
    return "（標準）";
   case "3E":
    return "（ややゆったり）";
   case "4E":
   case "5E":
    return "（ゆったり）";
   default:
    return "";
  }
 };

 const cardRef = useRef(null);
 const [isOpen, setIsOpen] = useState(false);
 const url = `https://kutsu.com/item/${item_inhouse_code}.html`;

 const ItemSizeRage = (item_size) => {
  const sizeArray = item_size.split(",");
  const minSize = sizeArray[0].replace("cm", "");
  const maxSize = sizeArray[sizeArray.length - 1];
  return minSize + "〜" + maxSize;
 };
 const item_size_min_max = ItemSizeRage(item_size); // ex. 22.5〜22.5cm
 const formattedPrice = (item_price) => Number(item_price).toLocaleString();
 //  const formattedPrice = (item_price) => Number(item_price).toLocaleString() + "円";

 useEffect(() => {
  const elBody = document.getElementsByTagName("body")[0];
  let scrollpos;

  if (!isOpen) return;

  scrollpos = window.scrollY;
  elBody.style.top = scrollpos * -1 + "px";
  elBody.style.position = "static";

  return () => {
   elBody.style.top = "";
   elBody.style.position = "";
   window.scrollTo(0, scrollpos);
  };
 }, [isOpen]);

 const handleMoreButtonClick = () => {
  // イベントをトラッキング
  trackButtonClick(item_inhouse_code, item_number, item_color_en);

  // モーダルを開く
  setIsOpen(true);
 };

 return (
  <>
   <div id={`f_${item_inhouse_code}`} className={`p-card p-filter-item js-filter-item`} data-card-id={`${id}`} data-card-category={`${item_category}`} ref={cardRef}>
    <button
     className="p-card__more-button--wrap p-card__modal-open-button"
     onClick={handleMoreButtonClick} // 修正
     aria-label={`${item_number} ${item_color_en}の詳細を見る`}
    >
     <figure className="p-card__photo">
      <LazyImage src={`/assets/images/item_photo/${item_inhouse_code}/th.jpg?${Config.cacheBuster}`} alt={`${item_number} ${item_color_en}`} width="600" height="600" loading="lazy" />
      {item_badge && (
       <>
        {item_badge === "New" && (
         <span className="p-card__badge p-card__badge--new">
          <span className="sr-only">{item_badge}</span>
         </span>
        )}
        {item_badge === "Limited" && (
         <span className="p-card__badge p-card__badge--limited">
          <span className="sr-only">{item_badge}</span>
         </span>
        )}
        {item_badge === "Sale" && (
         <span className="p-card__badge p-card__badge--sale">
          <span className="sr-only">{item_badge}</span>
         </span>
        )}
        {item_badge === "就活&入学式" && (
         <span className="p-card__badge p-card__badge--job-hunting">
          <span className="sr-only">{item_badge}</span>
         </span>
        )}
       </>
      )}
     </figure>
    </button>
   </div>

   <ItemModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
    <MySwiper value={{ item_inhouse_code, item_number, item_color_en, item_badge, item_total_images_2, item_total_images_3, item_total_video }} />
    <ItemModalBody item={props} item_size_min_max={item_size_min_max} formattedPrice={formattedPrice} url={url} getPrefixWidth={getPrefixWidth} className={className} />
   </ItemModal>
  </>
 );
}
